import React, { ReactNode } from 'react';
import './sections.less';

interface Props {
    children: ReactNode | ReactNode[];
    className?: string;
    dark?: boolean;
    title: string;
    titleAction?: ReactNode;
}

export function Section({ children, className = '', dark = false, title, titleAction }: Props) {
    return (
        <div className={`section-wrapper ${className} ${dark ? 'dark' : ''}`}>
            <div className="section-header">
                <h3 className="section-title">{title}</h3>
                {titleAction && <div className="section-title-action-container">{titleAction}</div>}
            </div>
            {children}
        </div>
    );
}
